/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import PostForm from './PostForm';
import { COMMUNUNNITY_NEW_POST } from '../../../constants/strings';
import { actions as newPostFormActions } from '../../../redux/communities/newPostForm';
import { actions as urlPreviewActions } from '../../../redux/common/urlPreview';
import styles from './index.styl';

const mapStateToProps = state => ({
  editPostRequest: state.communities.editPost,
});

const mapDispatchToProps = {
  updateForm: newPostFormActions.updateForm,
  clearForm: newPostFormActions.clearForm,
  clearUrlPreview: urlPreviewActions.clear,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles)
class EditPostPopup extends PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    communityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    editPost: PropTypes.func,
    updateForm: PropTypes.func,
    communityName: PropTypes.string,
    postId: PropTypes.number,
    editPostRequest: PropTypes.shape({
      sending: PropTypes.bool,
      rejected: PropTypes.bool,
      succeed: PropTypes.bool,
    }),
    forceOpened: PropTypes.bool,
    content: PropTypes.string,
    attachment: PropTypes.object,
    clearForm: PropTypes.func,
    clearUrlPreview: PropTypes.func,
  };

  static childContextTypes = {
    intl: PropTypes.object,
    store: PropTypes.object,
  };

  static contextTypes = {
    store: PropTypes.object,
  };

  state = {
    isOpened: false,
    error: null,
  };

  getChildContext() {
    return {
      intl: this.props.intl,
      store: this.context.store,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { content, attachment } = this.props;
    const { sending, succeed, error } = nextProps.editPostRequest;

    if (this.props.editPostRequest.sending && !sending) {
      if (succeed) {
        this.openPopup(false);
      } else {
        this.setState({ error: error.description });
      }
    }

    if (!this.props.forceOpened && nextProps.forceOpened) {
      this.props.updateForm({ content, attachment });
      this.openPopup();
    }
  }

  @autobind
  openPopup(isOpened = true) {
    const updates = {
      isOpened,
    };

    if (this.state.isOpened && !isOpened) {
      Object.assign(updates, { error: false });
      this.props.clearForm();
      this.props.clearUrlPreview();
    }

    this.setState(updates);
  }

  @autobind
  handleSubmit(data) {
    const { editPost, communityId, postId } = this.props;

    if (!communityId)
      throw new Error('EditPost: required communityId prop is missing');
    if (!data || !(data instanceof FormData))
      throw new Error('EditPost: wrong data passed');

    data.append('communityId', communityId);
    data.append('postId', postId);

    editPost(data);
  }

  render() {
    const {
      intl,
      communityName,
      intl: { formatMessage },
      editPostRequest: { sending },
      attachment,
    } = this.props;
    const { isOpened, error } = this.state;

    return (
      <div>
        <PostForm
          modalTitle={formatMessage(COMMUNUNNITY_NEW_POST.editTitle, {
            name: communityName,
          })}
          discardModalTitle={formatMessage({
            id: 'dialog.common.changesNotSave',
          })}
          isModalOpen={isOpened}
          submitting={sending}
          store={this.context.store}
          intl={intl}
          onSubmit={this.handleSubmit}
          onCancel={() => this.openPopup(false)}
          error={error}
          attachment={attachment}
          edit
          key={isOpened}
          discardBtnText={formatMessage({ id: 'profile.actions.cancel' })}
        />
      </div>
    );
  }
}

export default class EditPost extends PureComponent {
  state = {
    forceOpen: false,
  };

  componentDidUpdate() {
    if (this.state.forceOpen) this.setState({ forceOpen: false });
  }

  forceOpen() {
    this.setState({ forceOpen: true });
  }

  render() {
    return <EditPostPopup {...this.props} forceOpened={this.state.forceOpen} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/EditPost.jsx